import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getRollupAttributes } from '../../services/internal/rollup-service'
import { getPivotViews } from '../../services/internal/manage-pivot-view-service'

export const getRollupAttributesAction = createAsyncThunk(
  'rollup/getRollupAttributes',
  async eventId => {
    return await getRollupAttributes(eventId)
  },
)

export const getPivotViewsAction = createAsyncThunk(
  'rollup/getPivotViews',
  async (data: { userIds; type }) => {
    const { userIds, type } = data
    return await getPivotViews(userIds, type)
  },
)

const initialState = {
  isFetchingRollupAttributes: false,
  isFetchingPivotViews: false,
  sections: [],
  pivotViews: [],
}

const rollupSlice = createSlice({
  name: 'rollup',
  initialState,
  reducers: {
    resetRollupAction: state => {
      state.isFetchingRollupAttributes = false
      state.sections = []
    },
  },
  extraReducers: builder => {
    builder

      // getRollupAttributesAction
      .addCase(getRollupAttributesAction.pending, state => {
        state.isFetchingRollupAttributes = true
      })
      .addCase(getRollupAttributesAction.fulfilled, (state, action) => {
        state.isFetchingRollupAttributes = false
        state.sections = action.payload.data.sections
      })
      .addCase(getRollupAttributesAction.rejected, state => {
        state.isFetchingRollupAttributes = false
        state.sections = []
      })

      // getPivotViewsAction
      .addCase(getPivotViewsAction.pending, state => {
        state.isFetchingPivotViews = true
      })
      .addCase(getPivotViewsAction.fulfilled, (state, action) => {
        state.isFetchingPivotViews = false
        state.pivotViews = action.payload.data
      })
      .addCase(getPivotViewsAction.rejected, state => {
        state.isFetchingPivotViews = false
        state.pivotViews = []
      })
  },
})

export const { resetRollupAction } = rollupSlice.actions

export default rollupSlice.reducer
